<template>
  <product-card :product="product" :image="image" :module="module"/>
</template>

<script>
  import ProductCard from '@/components/marketplace/shared/ProductCard'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      },
      module: {
        type: Object,
        required: true
      }
    },
    computed: {
      image () {
        if (!this.product.images.length) {
          return ''
        }

        return this.product.images[0]
      }
    },
    components: {
      ProductCard
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px
</style>



// WEBPACK FOOTER //
// ProductCard.vue?ee613308